import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { bulkTaskerOnboard, cloneProjectConfig, cloneProjectStages, createProject, fetchProjectTypes, fetchTaskCategories, getProject, getProjectExperts, getProjectExpertsDeboard, getRoles, updateProject, updateProjectExpert, updateProjectExpertTaskLimit } from '../slices/projectSlice/addProjectSlice';
import { STATUS } from '../../utils/status';
import { ProjectTypeState } from '../interfaces/interface';

const ExtraReducers = (builder: ActionReducerMapBuilder<ProjectTypeState>) => {
  builder
    .addCase(createProject.pending, (state) => {
      state.createStatus = STATUS.PENDING;
      state.createProjectMessage = null
    })
    .addCase(createProject.fulfilled, (state, action: PayloadAction<any>) => {
      state.projects = action.payload;
      state.createStatus = STATUS.SUCESS;
      state.createProjectMessage = action.payload?.message || "Success"
    })
    .addCase(createProject.rejected, (state, action: any) => {
      state.createStatus = STATUS.FAILED;
      state.createProjectMessage = action.payload?.message || "An error occurred"
    }).addCase(cloneProjectConfig.pending, (state) => {
      state.cloneConfigStatus = STATUS.PENDING;
      state.cloneProjectConfigMessage = ""
    })
    .addCase(cloneProjectConfig.fulfilled, (state, action: PayloadAction<any>) => {
      state.projects = action.payload;
      state.cloneConfigStatus = STATUS.SUCESS;
      state.cloneProjectConfigMessage = action.payload?.message || "Success"
    })
    .addCase(cloneProjectConfig.rejected, (state, action: any) => {
      state.cloneConfigStatus = STATUS.FAILED;
      state.cloneProjectConfigMessage = action.payload?.message || "An error occurred"
    })
    .addCase(cloneProjectStages.pending, (state) => {
      state.cloneStageStatus = STATUS.PENDING;
      state.cloneProjectStageMessage = ""
    })
    .addCase(cloneProjectStages.fulfilled, (state, action: PayloadAction<any>) => {
      state.projects = action.payload;
      state.cloneStageStatus = STATUS.SUCESS;
      state.cloneProjectStageMessage = action.payload?.message || "Success"
    })
    .addCase(cloneProjectStages.rejected, (state, action: any) => {
      state.cloneStageStatus = STATUS.FAILED;
      state.cloneProjectStageMessage = action.payload?.message || "An error occurred"
    })

    .addCase(getProject.pending, (state) => {
      state.getStatus = STATUS.PENDING;
      state.getProjectMessage = null
    })
    .addCase(getProject.fulfilled, (state, action: PayloadAction<any>) => {
      if (Object.keys(action.payload).includes('project')) {
        state.project = action.payload.project;
        state.association_type = action.payload.association_type;
        state.permissions = action.payload.permissions;
      } else {
        state.projects = action.payload
      }
      state.getStatus = STATUS.SUCESS;
      state.getProjectMessage = action.payload?.message || "Success"
    })
    .addCase(getProject.rejected, (state, action: any) => {
      state.getStatus = STATUS.FAILED;
      state.getProjectMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getRoles.pending, (state) => {
      state.getStageRolesStatus = STATUS.PENDING;
      state.getStageRolesMessage = null
    })
    .addCase(getRoles.fulfilled, (state, action: PayloadAction<any>) => {
      console.log({aaaa: action.payload})
      state.roles.results = action.payload
      state.getStageRolesStatus = STATUS.SUCESS;
      state.getStageRolesMessage = action.payload?.message || "Success"
    })
    .addCase(getRoles.rejected, (state, action: any) => {
      state.getStageRolesStatus = STATUS.FAILED;
      state.getStageRolesMessage = action.payload?.message || "An error occurred"
    })
    .addCase(updateProjectExpert.pending, (state) => {
      state.updateProjectExpertStatus = STATUS.PENDING;
      state.updateProjectExpertsMessage = null
    })
    .addCase(updateProjectExpert.fulfilled, (state, action: PayloadAction<any>) => {
      state.projectExperts = action.payload
      state.updateProjectExpertStatus = STATUS.SUCESS;
      state.updateProjectExpertsMessage = action.payload?.message || "Success"
    })
    .addCase(updateProjectExpert.rejected, (state, action: any) => {
      state.updateProjectExpertStatus = STATUS.FAILED;
      state.updateProjectExpertsMessage = action.payload?.message || "An error occurred"
    })
    .addCase(updateProjectExpertTaskLimit.pending, (state) => {
      state.updateProjectExpertTaskLimitStatus = STATUS.PENDING;
      state.updateProjectExpertTaskLimitMessage = null
    })
    .addCase(updateProjectExpertTaskLimit.fulfilled, (state, action: PayloadAction<any>) => {
      state.projectExperts = action.payload
      state.updateProjectExpertTaskLimitStatus = STATUS.SUCESS;
      state.updateProjectExpertTaskLimitMessage = action.payload?.message || "Success"
    })
    .addCase(updateProjectExpertTaskLimit.rejected, (state, action: any) => {
      state.updateProjectExpertTaskLimitStatus = STATUS.FAILED;
      state.updateProjectExpertTaskLimitMessage = action.payload?.message || "An error occurred"
    })
    .addCase(updateProject.pending, (state) => {
      state.updateStatus = STATUS.PENDING;
      state.updateProjectMessage = null
    })
    .addCase(updateProject.fulfilled, (state, action: PayloadAction<any>) => {
      state.projects = action.payload.data;

      const reviewersFailed = action.payload?.data?.assignments?.reviewers?.failed;
      const taskersFailed = action.payload?.data?.assignments?.taskers?.failed;

      state.updateProjectMessage = reviewersFailed?.length
        ? reviewersFailed[0].reason
        : taskersFailed?.length
          ? taskersFailed[0].reason
          : '';

      if (Object.keys(action.payload.payload).includes('assign') && action.payload.payload.assign.taskers) {
        state.taskExperts.push({
          expert_id: action.payload.payload.assign.taskers[0],
          expert_email: action.payload.payload.email,
        });
      }
      if (Object.keys(action.payload.payload).includes('assign') && action.payload.payload.assign.reviewers) {
        state.reviewExperts.push({
          expert_id: action.payload.payload.assign.reviewers[0],
          expert_email: action.payload.payload.email,
        });
      }
      state.updateStatus = STATUS.SUCESS;
      state.updateProjectMessage = action.payload?.data.message || "Success"
    })
    .addCase(updateProject.rejected, (state, action: any) => {
      state.updateStatus = STATUS.FAILED;
      state.updateProjectMessage = action.payload?.message || "An error occurred"
    })
    .addCase(fetchProjectTypes.pending, (state) => {
      state.getProjectTypesStatus = STATUS.PENDING
      state.fetchProjectTypesMessage = null
    })
    .addCase(fetchProjectTypes.fulfilled, (state, action: PayloadAction<any>) => {
      state.getProjectTypesStatus = STATUS.SUCESS
      state.projectTypeOptions = action.payload;
      state.fetchProjectTypesMessage = null
    })
    .addCase(fetchProjectTypes.rejected, (state, action: any) => {
      state.getProjectTypesStatus = STATUS.FAILED
      state.fetchProjectTypesMessage = action.payload?.message || "An error occurred"
    })
    .addCase(bulkTaskerOnboard.pending, (state) => {
      state.bulkTaskerOnboardStatus = STATUS.PENDING
      state.bulkTaskerOnboardMessage = null
    })
    .addCase(bulkTaskerOnboard.fulfilled, (state, action: PayloadAction<any>) => {
      state.bulkTaskerOnboardStatus = STATUS.SUCESS
      state.projectTypeOptions = action.payload;
      state.bulkTaskerOnboardMessage = action.payload?.message
    })
    .addCase(bulkTaskerOnboard.rejected, (state, action: any) => {
      state.bulkTaskerOnboardStatus = STATUS.FAILED
      state.bulkTaskerOnboardMessage = action.payload?.message || "An error occurred"
    })
    .addCase(fetchTaskCategories.pending, (state) => {
      state.getTaskCategoryStatus = STATUS.PENDING
      state.fetchTaskCategoriesMessage = null
    })
    .addCase(fetchTaskCategories.fulfilled, (state, action: PayloadAction<any>) => {
      state.getTaskCategoryStatus = STATUS.SUCESS
      state.taskCategoryOptions = action.payload
      state.fetchTaskCategoriesMessage = null
    })
    .addCase(fetchTaskCategories.rejected, (state, action: any) => {
      state.getTaskCategoryStatus = STATUS.FAILED
      state.fetchTaskCategoriesMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getProjectExperts.pending, (state, action: PayloadAction<any>) => {
      state.getProjectExpertsStatus = STATUS.PENDING
      state.getProjectExpertsMessage = null
    })
    .addCase(getProjectExperts.fulfilled, (state, action: PayloadAction<any>) => {
      state.getProjectExpertsStatus = STATUS.SUCESS
      state.projectExperts = action.payload
      state.getProjectExpertsMessage = null
    })
    .addCase(getProjectExperts.rejected, (state, action: any) => {
      state.getProjectExpertsStatus = STATUS.FAILED
      state.getProjectExpertsMessage = action.payload?.message || "An error occurred"
    })
    .addCase(getProjectExpertsDeboard.pending, (state, action: PayloadAction<any>) => {
      state.getProjectExpertsDeboardStatus = STATUS.PENDING
      state.getProjectExpertsDeboardMessage = null
    })
    .addCase(getProjectExpertsDeboard.fulfilled, (state, action: PayloadAction<any>) => {
      state.getProjectExpertsDeboardStatus = STATUS.SUCESS
      state.getProjectExpertsDeboard = action.payload
      state.getProjectExpertsDeboardMessage = null
    })
    .addCase(getProjectExpertsDeboard.rejected, (state, action: any) => {
      state.getProjectExpertsDeboardStatus = STATUS.FAILED
      state.getProjectExpertsDeboardMessage = action.payload?.message || "An error occurred"
    })
};

export default ExtraReducers;
